import React from 'react';
import { cn } from '@/lib/utils';

interface BrandLogoProps {
  showText?: boolean;
  className?: string;
  iconClassName?: string;
  textClassName?: string;
}

export const BrandLogo: React.FC<BrandLogoProps> = ({
  showText = true,
  className,
  iconClassName,
  textClassName,
}) => {
  return (
    <div className={cn('inline-flex items-center gap-2 shrink-0', className)}>
      <img
        src="/luvall-logo.png"
        alt="LuvALL"
        className={cn('h-8 w-8 shrink-0 rounded-lg', iconClassName)}
      />
      {showText && (
        <span className={cn('font-semibold text-primary whitespace-nowrap', textClassName)}>
          LuvALL
        </span>
      )}
    </div>
  );
};

export default BrandLogo;
